import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import "./index.css";
import "./tailwind.css";
import App from "./App";
import { msalConfig } from "./auth/AuthConfig";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import { store } from "./redux/rootReducer";
import { Toaster } from "@/components/ui/toaster";

const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<MsalProvider instance={msalInstance}>
				<App />
			</MsalProvider>
		</Provider>
	</React.StrictMode>
);

// Mount toaster separately
const toasterRoot = ReactDOM.createRoot(document.getElementById("toaster-root"));
toasterRoot.render(<Toaster />);
